import type { ReactElement } from 'react';
import { useT } from '../di';
import { Button } from '../../ui-kit/Button/Button';
import { Icon } from '../../ui-kit/Icon/Icon';
import styles from './ConnectionBanner.module.scss';

export interface ConnectionBannerProps {
  visible: boolean;
  onReconnect(): void;
}

/** SYS-UC-13.CC-1: нет связи с сервером — панель под шапкой на любом экране, с кнопкой «Переподключить». */
export function ConnectionBanner({ visible, onReconnect }: ConnectionBannerProps): ReactElement | null {
  const { t } = useT();
  if (!visible) return null;
  return (
    <div className={styles.banner} role="status" aria-live="polite">
      <Icon name="warning" size={18} />
      <p className={styles.text}>
        <strong>{t('realtime.offline')}</strong> {t('realtime.offlineText')}
      </p>
      <Button size="sm" variant="secondary" onClick={onReconnect}>
        {t('realtime.reconnect')}
      </Button>
    </div>
  );
}
